import React from 'react';
import { ProductsType } from 'src/constants/products';
import { AgentCoSupportIcon } from 'src/assets/icons/agentCoSupportIcon';
import { CustomerCoSupportIcon } from 'src/assets/icons/customerCoSupportIcon';
import { BiCoSupportIcon } from 'src/assets/icons/biCoSupportIcon';
import { Button } from 'src/components/ui/button';
import { setProjectId } from 'src/store/slices/projectsSlices';
import { useAppDispatch } from 'src/store';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { Link } from 'react-router-dom';
import { clsx } from 'clsx';

export const CreateNewAgentCard = ({
  type = ProductsType.agent as string,
  isAdmin = true,
  navigationLink = '',
  disabled = false,
}) => {
  const dispatch = useAppDispatch();

  const addProjectHandler = (projectType) => {
    if (!disabled) {
      dispatch(setProjectId({ projectType }));
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="w-full p-5 pt-[25px] relative border shadow rounded-sm-5 shadow-[#00000040] border-[#E3E6E8] transition-all">
      <div className="flex gap-2 items-center">
        {(type === ProductsType.agent && <AgentCoSupportIcon width="19" height="19" />) ||
          (type === ProductsType.customer && <CustomerCoSupportIcon width="19" height="19" />) ||
          (type === ProductsType.bi && <BiCoSupportIcon width="19" height="19" />)}
        <p className="text-base font-jamjuree font-semibold">
          {(type === ProductsType.agent && 'AI Assistant') ||
            (type === ProductsType.customer && 'AI Agent') ||
            (type === ProductsType.bi && 'AI BI')}
        </p>
      </div>
      <p className="text-sm font-jamjuree font-medium opacity-50 text-start pt-2.5 pb-[15px]">
        {(type === ProductsType.agent &&
          'Generate smart reply suggestions for support agents inside a help desk.') ||
          (type === ProductsType.customer &&
            'Automate the resolution process for chats, emails and social media channels.') ||
          (type === ProductsType.bi &&
            'Turn internal data and customer correspondence into actionable insights.')}
      </p>
      <Link
        className={clsx(disabled && 'pointer-events-none')}
        target={!disabled ? (isAdmin ? '_self' : '_blank') : '_self'}
        onClick={() => addProjectHandler(type)}
        to={
          !disabled
            ? type === ProductsType.customer
              ? `${PATH_DASHBOARD.PROJECTS_NEW_STEP_1}?type=${type}`
              : isAdmin
                ? `${PATH_DASHBOARD.PROJECTS_NEW}?type=${type}`
                : navigationLink
            : ''
        }
      >
        <Button disabled={disabled} className="w-full">
          {isAdmin ? 'Create' : 'Request Access'}
        </Button>
      </Link>
    </div>
  );
};
